export const GALLERIES_PATH = id => `/libraries/${id}`
export const GALLERY_DELETE_IMAGE_PATH =  '/s3'